import { useEffect } from 'react';
import { connectWebSocket, disconnectWebSocket } from '@/lib';
import { useAuthStore } from '@/stores';

/**
 * Single owner of the WebSocket connection. The socket in `lib/ws-client.ts` is
 * a module singleton, so the connect/disconnect effect must live in exactly one
 * component mounted for the whole session. Owning it from a shared hook instead
 * (useAuth, called by every page) tore the socket down on every route change and
 * dropped anything emitted in the gap.
 *
 * Renders nothing; mounted once at the app root.
 */
export function WebSocketLifecycle() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const token = useAuthStore((s) => s.token);

  useEffect(() => {
    if (isAuthenticated && token) {
      connectWebSocket(token);
      return () => disconnectWebSocket();
    }

    disconnectWebSocket();
    return undefined;
  }, [isAuthenticated, token]);

  return null;
}
